export default __webpack_public_path__ + "static/HES-SO_INTERVIEWS_NINOTCHKA-d75571196cf59b3bbd1ce15bd6208ff7.jpg";